// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'jsx' is declared but its value is never read.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { css, jsx } from "@emotion/react";
import classNames from "classnames";
import * as React from "react";

const collapsibleCss = css`
  transition:
    max-height 0.2s ease,
    opacity 0.2s ease;
  opacity: 1;

  &.collapsed {
    max-height: 0 !important;
    overflow: hidden;
    opacity: 0;
  }
  &.hidden {
    visibility: hidden;
  }
`;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/naming-convention
interface CollapseProps {
  collapsed: boolean;
  children: React.ReactNode;
}

export class Collapse extends React.PureComponent<CollapseProps> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(props: any) {
    super(props);

    this.timeoutId = setTimeout(() => {
      this.setState({ collapsed: this.props.collapsed });
    }, 0);
  }

  state = { collapsed: true };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  UNSAFE_componentWillReceiveProps(nextProps: CollapseProps) {
    if (this.props.collapsed !== nextProps.collapsed) {
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      this.collapsedRef.current.style.maxHeight = `${this.collapsedRef.current.scrollHeight}px`;

      this.resetTimer();

      this.timeoutId = setTimeout(() => {
        this.setState({ collapsed: nextProps.collapsed });
      }, 0);
    }
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentWillUnmount() {
    this.resetTimer();
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleTransitionEnd = () => {
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    this.collapsedRef.current.style.maxHeight = null;
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private resetTimer() {
    clearTimeout(this.timeoutId);
  }

  collapsedRef: React.RefObject<HTMLDivElement> = React.createRef();

  timeoutId;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { collapsed } = this.state;
    return (
      <div
        aria-expanded={!collapsed}
        ref={this.collapsedRef}
        css={collapsibleCss}
        className={classNames({ collapsed })}
        onTransitionEnd={this.handleTransitionEnd}
      >
        {this.props.children}
      </div>
    );
  }
}
